class VgModal {
    constructor(options) {
        this.title = options.title;
        this.description = options.description;
        this.data = options.data;
        this.type = options.type || 'info'; // Types: 'success', 'warning', 'error', 'info', 'neutral'
        this.template = options.template || 'basic';
		this.status = options.status || ''; //Who send this Modal
		this.email =  options.email || '';
		this.old_external_id = options.old_external_id || ''; //This param will be used to actions over Previous User (normally a user without password set)

        this.render();
    }

    render() {
        const modalContainer = document.createElement('div');
        modalContainer.innerHTML = this.loadTemplate(this.template);
        document.body.appendChild(modalContainer);

        const dialog = modalContainer.querySelector('dialog');

        dialog.showModal();

        // Add event listener to close button
        const closeBtn = modalContainer.querySelector('.close-btn');
        const cancelBtn = modalContainer.querySelector('.cancel-btn');
		const langSelectorBtn = modalContainer.querySelector('.language-selector-btn');
        const chooseEmailForm = modalContainer.querySelector('.vg-form__choose-email');

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                const data = { action: 'modalClosed', status: this.status };
                document.dispatchEvent(new CustomEvent('modalClosed'), { detail: data });
                this.close(modalContainer);
            });
        }

        if (cancelBtn) {
            cancelBtn.addEventListener('click', () => {
                const data = { action: 'modalCancelled', status: this.status };
                document.dispatchEvent(new CustomEvent('modalCancelled', { detail: data }));
                this.close(modalContainer);
            });
        }

		if (langSelectorBtn) {
			langSelectorBtn.addEventListener('click', () => {
				const data = { action: 'modalLangSelectorBtn', status: this.status };
				document.dispatchEvent(new CustomEvent('modalLangSelectorBtn', { detail: data }));
				this.close(modalContainer);
			});
		}

		if (chooseEmailForm) {
			const submit = chooseEmailForm.querySelector('input[type="submit"]');

			chooseEmailForm.addEventListener('input', (event) => {
				event.preventDefault();
				const allFilled = chooseEmailForm.querySelector('input:checked');
				submit.disabled = !allFilled;
			});
			chooseEmailForm.addEventListener('submit', (event) => {
				event.preventDefault();
				const selectedOption = chooseEmailForm.querySelector('input:checked');

				const data = { email: selectedOption.value, old_external_id: this.old_external_id };
				document.dispatchEvent(new CustomEvent('modalEmailSelect', { detail: data }));
				console.log('Event: modalEmailSelect', data);
				this.close(modalContainer);
			});
		}

        // Add event listener to close modal on clicking outside
        if (closeBtn) {
            let touchStartTime = 0;
            dialog.addEventListener('touchstart', (e) => {
                touchStartTime = Date.now();
            }, { passive: true });
            dialog.addEventListener('click', (event) => {
                // Prevent click event that comes after a touch from closing the modal.
                const timeSinceTouch = Date.now() - touchStartTime;
                if (timeSinceTouch < 300) {
                    event.stopPropagation();
                    return;
                }
                const data = { action: 'modalClosed' };
                if (event.target === dialog) {
					document.dispatchEvent(new CustomEvent('modalClosed'), { detail: data });
                    this.close(modalContainer);
                }
            });
        }

		document.addEventListener('VgLogin', (event) => {
			if (event.detail.success) {
				this.close(modalContainer);
			}
		});
    }

    // Method to close the modal
    close(modalContainer) {
        const dialog = modalContainer.querySelector('dialog');
		if (dialog) {
			dialog.close();
			document.body.removeChild(modalContainer);
		}
    }

    // Method to get template based on template name
    loadTemplate(templateName) {
        // Define templates
        const templates = {
            basic:
            `
            <dialog class="vg-modal ${this.type}">
                <button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
                <div class="vg-modal__content">
                    <h2 class="vg-modal__title has-h-3-font-size"><span class="icon icon--size-l icon--${this.type}"></span>${this.title}</h2>
                    <div>${this.description}</div>
                </div>
            </dialog>
            `,
            default:
            `
            <dialog class="vg-modal vg-modal-default ${this.type}">
                <button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
                <div class="vg-modal__content">
                    ${ this.title !== "" ? `<h2 class="vg-modal__title has-h-3-font-size">${this.title}</h2>` : '' }
                    <div class="vg-modal__content_detail">${this.description}</div>
                </div>
            </dialog>
            `,
            qr:
            `
            <dialog class="vg-modal vg-modal-qr ${this.type}">
                <button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
                <div class="vg-modal__content vg-landing-welcome__btns-download">
                    <h2 class="vg-modal__title has-h-3-font-size">${this.title}</h2>
                    <div class="vg-landing-welcome__image-qr btn-download-${this.data[0]}"></div>
                </div>
            </dialog>
            `,
            login:
            `
            <dialog class="vg-modal ${this.type}">
                <div class="vg-modal__content">
                    <h2 class="vg-modal__title has-h-3-font-size"></span>${this.title}</h2>
                    <p>${this.description}</p>
                        <vg-login submit-text="Iniciar Sesión" cancel-text="Cancelar" email-value="${this.email}">
		                </vg-login>
                </div>
            </dialog>
            `,
			countrySelector:
			`
            <dialog class="vg-modal ${this.type}">
                <button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
                <div class="vg-modal__content">
                    <h2 class="vg-modal__title has-h-3-font-size"><span class="icon icon--size-l icon--${this.type}"></span>${this.title}</h2>
                    <div>${this.description}</div>
					<div class='vg-modal-country-selector__content-button'>
						<button type='button' class='language-selector-btn ob-button ob-button--primary'>${( typeof vgHelpersData !== 'undefined' && vgHelpersData.modal_buttons?.accept ) || 'Aceptar'}</button>
					</div>
                </div>
            </dialog>
            `,
            email:
            `
            <dialog class="vg-modal ${this.type}">
                <button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
                <div class="vg-modal__content">
                    <h2 class="vg-modal__title has-h-3-font-size"><span class="icon icon--size-l icon--${this.type}"></span>${this.title}</h2>
                    <div>${this.description}</div>
                    <form class="vg-form__choose-email" method='POST'>
						<div class="vg-form__field-group vg-form__field-group--radios is-required">
    						<div class="vg-form__radios-elements">
								${this.data.map((email, index) => `
								<div class="vg-form__field-element">
								<input type="radio" id="choose-email-${index + 1}" name="choose-email" value="${email}">
								<label for="choose-email-${index + 1}">${email}</label>
								</div>`).join('')}
							</div>
						</div>
						<div class="vg-modal__cta">
							<input type="submit" class="ob-button ob-button--primary" disabled value="Guardar">
						</div>
                    </form>
                </div>
            </dialog>
            `,
			trainer:
			`
			<dialog class="vg-modal vg-modal-default ${this.type}">
				<button class="close-btn"><span class="icon icon--size-s icon--close"></span></button>
				<div class="vg-modal__content">
					${this.description}
				</div>
			</dialog>
			`,
        };

        return templates[templateName];
    }
}

// Usage example:

/* Basic
new VgModal({
    title: 'Success',
    description: 'This is a success message.',
    type: 'success', // Types: 'success', 'warning', 'error', 'info', 'neutral'
    template: 'basic',
});
*/

/* Login
new VgModal({
    title: 'Parece que ya fuiste miembro',
    description: 'Tu DNI ya está en nuestra base de datos. Inicia sesión para poder continuar.',
    type: 'neutral', // Types: 'success', 'warning', 'error', 'info', 'neutral'
    template: 'login',
});
*/

/* Email selection
new VgModal({
    title: 'Selecciona tu email',
    description: 'Tu email ya existe en nuestra base de datos. Selecciona uno de los siguientes:',
    data: ['test@test.com', 'test2@test2.com'],
    type: 'warning', // Types: 'success', 'warning', 'error', 'info', 'neutral'
    template: 'email',
});
*/
